import CountryForm from '@/components/Country/CountryForm/CountryForm.vue';
import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import ICountry from '@/interfaces/countries/ICountry';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'CountryDetail',
    components: {
        Loader,
        CardHeader,
        CountryForm
    }
})
export default class CountryDetail extends Vue {
    @Prop(Object) private countryData!: ICountry;

    @Action private updateCountry!: (form: ICountry) => Promise<void>;
    @Action private getCountry!: (id: string) => Promise<ICountry>;

    private countryDataFromBackend: ICountry | null =  null;

    private loading: boolean = true;

    private isEdit: boolean = false;

    private get btnIcon() {
        return !this.isEdit ? 'icon-pencil' : 'icon-lock';
    }

    private get editBtnText() {
        return !this.isEdit ? 'Edit' : 'Lock';
    }

    private get countryId() {
        return this.$route.params.id;
    }

    private get formData() {
        return this.countryDataFromBackend || this.countryData
    }

    private editForm() {
        return (this.isEdit = !this.isEdit);
    }

    private countryUpdate(form: ICountry) {
        this.updateCountry(form);
    }

    private async mounted() {
        try {
            console.log(this.countryData)
            if (!this.countryData) {
                this.countryDataFromBackend = await this.getCountry(this.countryId);
            }
            this.loading = false;
        } catch {
            return void 0;
        }
    }
}